import React, { useEffect, useLayoutEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledPopover,
  PopoverBody,
  Button,
} from "reactstrap";
import { useRecoilState } from "recoil";
import { languageState } from "../atoms";
import { Trans, useTranslation } from "react-i18next";
import arabiclg from '../assets/images/arabic-icon.png';
import englishlg from '../assets/images/english-icon.png';
import  spanishlg from '../assets/images/spanish-icon.png';
import  frenchlg from '../assets/images/french-icon.png';
import indonesianlg from '../assets/images/indonesian-icon.png';


export const LanguageSwitcher = ({ 
  isInTrialPeriod, 
  languageOptions, 
  subscribedLanguages, 
  isAuthenticated, 
  isAdmin,
}) => {
  const history = useHistory()
  const [isOpen, setIsOpen] = useState();
  const [language, setLanguage] = useRecoilState(languageState);
  const { i18n } = useTranslation();
  const [languageData, setLanguageData] = useState(languageOptions?.find(item => item.code === languageState ));
  
  useLayoutEffect(() => {
    setImmediate(() => {
      i18n.changeLanguage(language);
    })
  }, [language, i18n]);


  useEffect(() => {
    if(languageData === undefined){
      setLanguageData(languageOptions?.find(item => item.code === i18n.language))
    }
  }, [languageData, languageOptions])
  

//   useEffect(() => {
//     if (!languageData && languageOptions.length > 0) {
//         let selectedLang = languageOptions[0]
//         setLanguageData(selectedLang)
//         setLanguage(selectedLang.code)
//     }
//   }, [languageOptions])

  const onLanguageChange = (language) => {
    setLanguageData(language)
    setLanguage(language.code)
  }

  const goToCustomizeSubscriptionPage = () => {
    history.push({
      pathname: '/customize-subscription',
      search: `from=lang`
    })
  }

  return (
    <>
    <Dropdown isOpen={isOpen} toggle={() => setIsOpen((v) => !v)} nav className="float-right lng">
        <DropdownToggle nav caret className="d-flex mr-2">
        <img width="28" className="px-1 py-1" src={`/images/${(languageData && languageData.label || "English").toLowerCase()}-icon.png`} alt="ar"></img>
        <span className="py-1">{(languageData && languageData.label) || "English"}</span>
        <i className="fa fa-angle-down" aria-hidden="true" style={{color:'#72B566', padding:'4px 3px 0px 3px'}}></i>
        </DropdownToggle>
        <DropdownMenu>
            {/* <DropdownItem onClick={() => setLanguage("en")}>
                <img width="28" className="w-1 p-1"
                    src="/images/english-icon.png"
                    alt="en"
                />English</DropdownItem> */}
        <div className="my-2"/>
        
        {
            languageOptions && languageOptions.map(item => {
                return (
                    <DropdownItem onClick={() => onLanguageChange(item)} key={item.code}>
                        <img 
                            width="28" 
                            className="w-1 p-1"
                            src={`/images/${item.label.toLowerCase()}-icon.png`}
                            alt={item.code}
                        />
                        {item.label}
                    </DropdownItem>
                )
            })
        }
        {(!isInTrialPeriod && isAuthenticated && !isAdmin) && 
          <div className="text-center mt-2">
            <Button size="sm" color="primary" onClick={goToCustomizeSubscriptionPage}><Trans>Buy More</Trans></Button>
          </div>
        }
      </DropdownMenu>
      </Dropdown> 
         
        
                </>
  );
};
